export const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.justgold";
export const IOS_APP_URL = "https://apps.apple.com/in/app/just-gold/id6744900430";

export type DeviceOS = "ios" | "android" | "other";

// iPhone/iPad/iPod and Macs map to "ios" — Mac users belong on the App Store,
// not Google Play. iPadOS 13+ reports a desktop Mac user agent, so the "mac"
// check covers it too. Android is checked first: no Android UA contains "mac".
export function detectDeviceOS(): DeviceOS {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent.toLowerCase();
  if (/android/.test(ua)) return "android";
  if (/iphone|ipad|ipod|macintosh|mac os x/.test(ua)) return "ios";
  return "other";
}

// Windows, Linux and unknown devices fall back to the Play Store.
export function getAppStoreUrl(os: DeviceOS): string {
  return os === "ios" ? IOS_APP_URL : ANDROID_APP_URL;
}
